module.exports = function() {
  return new Worker("/" + "sass-transpiler.22a16611.worker.js");
};